import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=3fd448a7&scoped=true"
import script from "./timeline.vue?vue&type=script&lang=js"
export * from "./timeline.vue?vue&type=script&lang=js"
import style0 from "./timeline.vue?vue&type=style&index=0&id=3fd448a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd448a7",
  null
  
)

export default component.exports